(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-blend-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initGallery(root) {
    const track = root.querySelector('[data-ssc-gallery-track]');
    const prev = root.querySelector('[data-ssc-gallery-prev]');
    const next = root.querySelector('[data-ssc-gallery-next]');
    const tiles = Array.from(root.querySelectorAll('[data-ssc-gallery-tile]'));
    if (!track || !tiles.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Step by one tile, measured from the live layout rather than the setting,
    // so the mobile min() width and the flex gap are both accounted for.
    function step() {
      if (tiles.length < 2) return tiles[0].offsetWidth;
      return tiles[1].offsetLeft - tiles[0].offsetLeft;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function syncArrows() {
      // 1px of slack: sub-pixel layout means scrollLeft rarely hits the ends exactly.
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft >= maxScroll() - 1;
      prev.disabled = atStart;
      next.disabled = atEnd;
      // Nothing to page through — hide the arrows rather than show two dead buttons.
      root.querySelector('.ssc-blend-gallery__nav').hidden = maxScroll() <= 1;
    }

    function scrollByTiles(dir) {
      track.scrollLeft += dir * step();
    }

    prev.addEventListener('click', () => { stopAuto(); scrollByTiles(-1); });
    next.addEventListener('click', () => { stopAuto(); scrollByTiles(1); });
    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();

    let timer = null;
    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    const autoplay = root.dataset.autoplay === 'true';
    const delay = Math.max(1000, parseInt(root.dataset.autoplayDelay, 10) || 3000);
    if (autoplay && !reduceMotion) {
      timer = setInterval(() => {
        if (maxScroll() <= 1) return;
        // Wrap at the end so the range keeps cycling instead of parking.
        if (track.scrollLeft >= maxScroll() - 1) track.scrollLeft = 0;
        else scrollByTiles(1);
      }, delay);

      // Any deliberate interaction means the visitor is driving now.
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(evt => {
        root.addEventListener(evt, stopAuto, { once: true, passive: true });
      });
      root.addEventListener('focusin', stopAuto, { once: true });
      // Don't animate a tab nobody is looking at.
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAuto();
      });
    }
  }

  document.querySelectorAll('[data-ssc-blend-gallery]').forEach(initGallery);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-blend-order"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SF_API = '/api/2025-01/graphql.json';
  const SF_TOKEN = '8d390008d0df12ba863e973e6bfc926b';
  const SF_VARIANTS_QUERY = `
    query($handle: String!, $after: String) {
      product(handle: $handle) {
        options { name }
        variants(first: 250, after: $after) {
          pageInfo { hasNextPage endCursor }
          nodes { id title sku availableForSale price { amount } selectedOptions { name value } }
        }
      }
    }`;

  // Returns variants in the same shape the Liquid blob emits, so nothing
  // downstream can tell which source it got. Mirrors the matrix helper.
  async function fetchAllVariants(handle) {
    const nodes = [];
    let optionNames = [];
    let after = null;
    for (let page = 0; page < 10; page++) {
      const res = await fetch(SF_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
        body: JSON.stringify({ query: SF_VARIANTS_QUERY, variables: { handle, after } })
      }).then(r => r.json());
      const product = res && res.data && res.data.product;
      if (!product || !product.variants) throw new Error('no product data for ' + handle);
      if (!optionNames.length) optionNames = (product.options || []).map(o => o.name);
      product.variants.nodes.forEach(n => nodes.push(n));
      if (!product.variants.pageInfo.hasNextPage) break;
      after = product.variants.pageInfo.endCursor;
    }
    return nodes.map(n => {
      const options = [null, null, null];
      (n.selectedOptions || []).forEach(o => {
        const i = optionNames.indexOf(o.name);
        if (i > -1 && i < 3) options[i] = o.value;
      });
      return {
        // Storefront ids are gids; the cart wants the numeric suffix.
        id: parseInt(String(n.id).split('/').pop(), 10),
        sku: n.sku || '',
        available: !!n.availableForSale,
        price_cents: Math.round(parseFloat(n.price.amount) * 100),
        options
      };
    });
  }

  function initBlend(root) {
    const dataEl = root.querySelector('[data-ssc-blend-data]');
    if (!dataEl) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const hiddenPlatings = data.hidden_platings || [];
    const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
    const cartUrl = root.dataset.cartUrl || '/cart';
    const submitBtn = root.querySelector('[data-ssc-blend-submit]');
    const submitLabel = root.querySelector('[data-ssc-blend-submit-label]');
    const errorEl = root.querySelector('[data-ssc-blend-error]');
    const piecesEl = root.querySelector('[data-ssc-blend-pieces]');
    const subtotalEl = root.querySelector('[data-ssc-blend-subtotal]');

    // Matches ssc-product-bulk-matrix.liquid's formatter exactly — wholesale is
    // quoted in whole dollars, and the two surfaces must not disagree on a price.
    function money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    const byHandle = {};
    (data.products || []).forEach(p => { byHandle[p.handle] = p; });

    const rows = Array.from(root.querySelectorAll('[data-ssc-blend-row]')).map(rowEl => {
      const product = byHandle[rowEl.dataset.handle];
      if (!product) return null;
      const selects = Array.from(rowEl.querySelectorAll('[data-ssc-blend-opt]'));
      const qtyEl = rowEl.querySelector('[data-ssc-blend-qty]');
      const priceEl = rowEl.querySelector('[data-ssc-blend-price]');
      const lineEl = rowEl.querySelector('[data-ssc-blend-line]');
      const skuEl = rowEl.querySelector('[data-ssc-blend-sku]');
      return { rowEl, product, selects, qtyEl, priceEl, lineEl, skuEl, variant: null };
    }).filter(Boolean);

    // A variant matches when every option position the buyer has chosen agrees.
    function findVariant(product, chosen) {
      return product.variants.find(v =>
        chosen.every((val, i) => val === null || v.options[i] === val)
      ) || null;
    }

    // Narrow each select to values still reachable given the OTHER selections,
    // so a buyer can't build a combination that doesn't exist. Values that
    // would dead-end are removed rather than disabled — per the brief,
    // unavailable choices are not shown.
    function refreshOptions(row) {
      const chosen = row.selects.map(s => s.value || null);
      row.selects.forEach((sel, idx) => {
        const others = chosen.slice();
        others[idx] = null;
        const reachable = new Set();
        row.product.variants.forEach(v => {
          if (others.every((val, i) => val === null || v.options[i] === val)) {
            if (v.options[idx] != null) reachable.add(v.options[idx]);
          }
        });
        const current = sel.value;
        Array.from(sel.options).forEach(opt => {
          opt.hidden = !reachable.has(opt.value);
        });
        // If the current pick just became unreachable, fall to the first that is.
        if (!reachable.has(current)) {
          const next = Array.from(sel.options).find(o => !o.hidden);
          if (next) sel.value = next.value;
        }
      });
    }

    function updateRow(row) {
      refreshOptions(row);
      const chosen = row.selects.map(s => s.value || null);
      const variant = findVariant(row.product, chosen);
      row.variant = variant;

      if (!variant) {
        row.rowEl.classList.add('ssc-blend__row--unavailable');
        row.priceEl.textContent = '—';
        row.skuEl.textContent = '';
        row.qtyEl.value = '';
        row.qtyEl.disabled = true;
        row.lineEl.hidden = true;
        return;
      }
      row.rowEl.classList.remove('ssc-blend__row--unavailable');
      row.qtyEl.disabled = false;
      row.priceEl.textContent = money(variant.price_cents);
      row.skuEl.textContent = variant.sku || '';
    }

    function recalc() {
      let pieces = 0;
      let subtotal = 0;
      rows.forEach(row => {
        const q = parseInt(row.qtyEl.value, 10) || 0;
        row.qtyEl.classList.toggle('has-val', q > 0);
        if (q > 0 && row.variant) {
          pieces += q;
          const line = q * row.variant.price_cents;
          subtotal += line;
          row.lineEl.textContent = money(line);
          row.lineEl.hidden = false;
        } else {
          row.lineEl.hidden = true;
        }
      });
      piecesEl.textContent = String(pieces);
      subtotalEl.textContent = money(subtotal);
      submitBtn.disabled = pieces === 0;
    }

    // Accordion: reveal the same silhouette across the other roses. The rows
    // inside are ordinary rows — already wired above — so opening the panel
    // needs no more than a visibility toggle.
    root.querySelectorAll('[data-ssc-roses-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });

    rows.forEach(row => {
      row.selects.forEach(sel => {
        sel.addEventListener('change', () => { updateRow(row); recalc(); });
      });
      row.qtyEl.addEventListener('input', recalc);
      updateRow(row);
    });
    recalc();

    // Products at the 250-variant ceiling were truncated by Liquid; pull the
    // real set so their dropdowns and prices are complete. Done after first
    // paint so the page is usable immediately.
    rows.filter(r => r.product.truncated).forEach(async row => {
      try {
        let variants = await fetchAllVariants(row.product.handle);
        if (hiddenPlatings.length) {
          // SSC B2B: accepts both 'Plating' and 'Metal Finish' during the rename to match D2C (DigitBridge parity). Drop the old name once the catalog rename lands.
          let platingIdx = row.product.option_names.indexOf('Metal Finish');
          if (platingIdx === -1) platingIdx = row.product.option_names.indexOf('Plating');
          if (platingIdx > -1) {
            variants = variants.filter(v => !hiddenPlatings.includes(v.options[platingIdx]));
          }
        }
        row.product.variants = variants;
        updateRow(row);
        recalc();
      } catch (err) {
        // Leave the truncated set in place — a short dropdown beats a broken row.
        console.warn('[ssc-blend] variant refetch failed for', row.product.handle, err);
      }
    });

    submitBtn.addEventListener('click', async () => {
      const items = [];
      rows.forEach(row => {
        const q = parseInt(row.qtyEl.value, 10) || 0;
        if (q > 0 && row.variant) items.push({ id: row.variant.id, quantity: q });
      });
      if (!items.length) return;
      submitBtn.disabled = true;
      submitLabel.textContent = 'Adding…';
      errorEl.hidden = true;

      // Same cart contract as the matrix: form-encoded POST so Shopify fills
      // response.sections with rendered drawer HTML, and prefer cart-drawer
      // because cart-notification can't render a multi-item add.
      const cart = document.querySelector('cart-drawer');
      const formData = new FormData();
      items.forEach((item, i) => {
        formData.append(`items[${i}][id]`, String(item.id));
        formData.append(`items[${i}][quantity]`, String(item.quantity));
      });
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(s => s.id).join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(submitBtn);
      }

      try {
        const r = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const response = await r.json().catch(() => ({}));
        if (!r.ok || response.status) {
          throw new Error(response.description || response.message || `cart add failed (${r.status})`);
        }
        if (cart) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ssc-blend-order', cartData: response });
          }
          cart.renderContents(response);
          rows.forEach(row => { row.qtyEl.value = ''; row.qtyEl.classList.remove('has-val'); });
          submitBtn.disabled = false;
          submitLabel.textContent = data.submit_label || 'Add to order →';
          recalc();
        } else {
          window.location.href = cartUrl;
        }
      } catch (err) {
        errorEl.textContent = err.message || 'Could not add to cart. Please try again.';
        errorEl.hidden = false;
        submitBtn.disabled = false;
        submitLabel.textContent = data.submit_label || 'Add to order →';
        recalc();
      }
    });
  }

  document.querySelectorAll('[data-ssc-blend]').forEach(initBlend);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-browse-jumpnav"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ssc-jumpnav]').forEach((nav) => {
    const tabs = nav.querySelectorAll('[data-target]');
    if (!tabs.length) return;

    const targetIds = Array.from(tabs).map((t) => t.dataset.target).filter(Boolean);
    const sections = targetIds.map((id) => document.getElementById(id)).filter(Boolean);
    if (!sections.length) return;

    const activate = (id) => {
      tabs.forEach((t) => {
        t.classList.toggle('ssc-bl-jumpnav__tab--active', t.dataset.target === id);
      });
    };

    const observer = new IntersectionObserver((entries) => {
      // Pick the entry that's most visible AND nearest to viewport top
      const visible = entries.filter((e) => e.isIntersecting);
      if (!visible.length) return;
      visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      activate(visible[0].target.id);
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });

    sections.forEach((s) => observer.observe(s));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-browse-megamenu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const menu = document.querySelector('[data-ssc-megamenu]');
    const trigger = document.getElementById('sscBrowseTrigger');
    const mobileToggle = document.querySelector('[data-ssc-nav-mobile-toggle]');
    const mobileClose = menu && menu.querySelector('[data-ssc-megamenu-close]');
    const backdrop = document.querySelector('[data-ssc-megamenu-backdrop]');
    if (!menu || !trigger) return;

    const featureLink     = menu.querySelector('[data-ssc-megamenu-feature]');
    const featureImage    = menu.querySelector('[data-ssc-feature-image]');
    const featureEyebrow  = menu.querySelector('[data-ssc-feature-eyebrow]');
    const featureTitle    = menu.querySelector('[data-ssc-feature-title]');
    const featureDesc     = menu.querySelector('[data-ssc-feature-desc]');

    // Default state captured from data-* on the menu root (set in Liquid).
    const defaultEyebrow = menu.dataset.defaultEyebrow || '';
    const defaultDesc    = menu.dataset.defaultDesc || '';
    const defaultImage   = menu.dataset.defaultImage || '';
    const defaultFocal   = menu.dataset.defaultFocal || '50% 50%';
    const defaultTarget  = menu.dataset.defaultTarget || '#';
    // Default title is pipe-encoded (part1|emphasis|part2) so we can rebuild
    // the bold pattern without parsing innerHTML on init.
    const titleParts = (menu.dataset.defaultTitle || '||').split('|');
    const defaultTitleHTML = (titleParts[0] ? titleParts[0] + ' ' : '')
      + (titleParts[1] ? '<b>' + titleParts[1] + '</b>' : '')
      + (titleParts[2] ? ' ' + titleParts[2] : '');

    // isDefault: only the resting panel (the New Drop) is a real destination.
    // While hovering a collection the panel is a preview of the link the buyer
    // is already pointing at, so the CTA is hidden and the panel stops being
    // clickable — two affordances for one action reads as a second choice.
    function setFeature(eyebrow, titleHTML, desc, imageUrl, target, focal, isDefault) {
      clearTimeout(resetTimer);
      if (featureLink) featureLink.classList.toggle('ssc-megamenu-feature--preview', !isDefault);
      featureEyebrow.textContent = eyebrow || '';
      featureTitle.innerHTML = titleHTML || '';
      featureDesc.textContent = desc || '';
      if (imageUrl) {
        featureImage.style.backgroundImage = `url('${imageUrl}')`;
        featureImage.style.backgroundSize = 'cover';
        // The panel is a background-image, so the file's focal point has to be
        // applied as background-position — object-position does nothing here.
        featureImage.style.backgroundPosition = focal || '50% 50%';
      } else {
        featureImage.style.backgroundImage = '';
      }
      if (featureLink && target) featureLink.setAttribute('href', target);
    }

    function resetFeature() {
      setFeature(defaultEyebrow, defaultTitleHTML, defaultDesc, defaultImage, defaultTarget, defaultFocal, true);
    }

    let resetTimer = null;
    function scheduleReset() {
      clearTimeout(resetTimer);
      resetTimer = setTimeout(resetFeature, 80);
    }

    function openMenu() {
      menu.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        menu.classList.add('open');
        if (backdrop) backdrop.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ssc-megamenu-open');
      }));
    }

    function closeMenu() {
      menu.classList.remove('open');
      if (backdrop) backdrop.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ssc-megamenu-open');
      setTimeout(() => {
        if (!menu.classList.contains('open')) menu.hidden = true;
      }, 260);
      resetFeature();
    }

    function toggleMenu() {
      if (menu.classList.contains('open')) closeMenu();
      else openMenu();
    }

    trigger.addEventListener('click', (e) => { e.stopPropagation(); toggleMenu(); });
    if (mobileToggle) mobileToggle.addEventListener('click', (e) => { e.stopPropagation(); toggleMenu(); });
    if (mobileClose) mobileClose.addEventListener('click', closeMenu);
    if (backdrop) backdrop.addEventListener('click', closeMenu);

    // Outside-click closes.
    document.addEventListener('click', (e) => {
      if (!menu.classList.contains('open')) return;
      if (menu.contains(e.target)) return;
      if (trigger.contains(e.target)) return;
      if (mobileToggle && mobileToggle.contains(e.target)) return;
      closeMenu();
    });

    // Esc closes (returns focus to trigger).
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.classList.contains('open')) {
        closeMenu();
        trigger.focus();
      }
    });

    // Hover/focus → swap editorial panel.
    menu.querySelectorAll('.ssc-megamenu-link').forEach((link) => {
      const handler = () => setFeature(
        link.dataset.featEyebrow,
        link.dataset.featTitle,
        link.dataset.featDesc,
        link.dataset.featImage,
        link.getAttribute('href'),
        link.dataset.featFocal
      );
      link.addEventListener('mouseenter', handler);
      link.addEventListener('focus', handler);
      link.addEventListener('mouseleave', scheduleReset);
      link.addEventListener('blur', scheduleReset);
    });

    // Keyboard nav within / across columns.
    const COLUMN_SELECTOR = '.ssc-megamenu-list';
    menu.addEventListener('keydown', (e) => {
      const target = document.activeElement;
      if (!target.classList.contains('ssc-megamenu-link')) return;
      const currentList = target.closest(COLUMN_SELECTOR);
      if (!currentList) return;
      const allLists = Array.from(menu.querySelectorAll(COLUMN_SELECTOR));
      const currentColIdx = allLists.indexOf(currentList);
      const itemsInCol = Array.from(currentList.querySelectorAll('.ssc-megamenu-link'));
      const currentRowIdx = itemsInCol.indexOf(target);
      let nextEl = null;
      switch (e.key) {
        case 'ArrowDown':
          nextEl = itemsInCol[currentRowIdx + 1] || itemsInCol[0];
          break;
        case 'ArrowUp':
          nextEl = itemsInCol[currentRowIdx - 1] || itemsInCol[itemsInCol.length - 1];
          break;
        case 'ArrowRight': {
          const nextCol = allLists[currentColIdx + 1] || allLists[0];
          const nextItems = Array.from(nextCol.querySelectorAll('.ssc-megamenu-link'));
          nextEl = nextItems[Math.min(currentRowIdx, nextItems.length - 1)];
          break;
        }
        case 'ArrowLeft': {
          const prevCol = allLists[currentColIdx - 1] || allLists[allLists.length - 1];
          const prevItems = Array.from(prevCol.querySelectorAll('.ssc-megamenu-link'));
          nextEl = prevItems[Math.min(currentRowIdx, prevItems.length - 1)];
          break;
        }
        default: return;
      }
      if (nextEl) {
        e.preventDefault();
        nextEl.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-cart-bundle-completer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-ssc-completer]');
  if (!root) return;

  // Per-order cap agreed 2026-08-10. Enforced here for the buying flow; it is
  // not a per-customer limit and nothing client-side could enforce one.
  const MAX_SETS = 5;

  const L = {
    heading: root.dataset.heading || 'Complete your',
    choose: root.dataset.chooseLabel || 'Choose a colorway',
    add: root.dataset.addLabel || 'Add',
    adding: root.dataset.addingLabel || 'Adding…',
  };

  async function build() {
    let data, cart;
    try {
      [data, cart] = await Promise.all([
        fetch(root.dataset.src).then(r => r.json()),
        fetch('/cart.js').then(r => r.json()),
      ]);
    } catch (err) {
      // Silent: this is an enhancement on a working cart, not the cart itself.
      console.warn('[ssc-completer] could not load bundle data', err);
      return;
    }

    // variant id -> design handle, so a cart line can be traced to a design.
    const owner = new Map();
    Object.entries(data.by_product || {}).forEach(([handle, entries]) => {
      entries.forEach(e => owner.set(String(e.id), handle));
    });

    // Units per design, per grouping — quantity matters now that sets stack.
    const counts = {};
    (cart.items || []).forEach(item => {
      const handle = owner.get(String(item.variant_id));
      if (!handle) return;
      const group = data.products[handle]?.group;
      if (!group) return;
      counts[group] = counts[group] || {};
      counts[group][handle] = (counts[group][handle] || 0) + (item.quantity || 0);
    });

    root.innerHTML = '';
    let shown = 0;

    Object.entries(counts).forEach(([group, byHandle]) => {
      const all = data.groups[group] || [];
      if (!all.length) return;
      // Complete sets = the weakest link, not the total number of pieces.
      const sets = Math.min(...all.map(h => byHandle[h] || 0));
      if (sets >= MAX_SETS) return;          // at the per-order cap
      const target = sets + 1;
      const missing = all
        .map(h => ({ handle: h, need: target - (byHandle[h] || 0) }))
        .filter(x => x.need > 0);
      if (!missing.length) return;
      shown++;

      const box = document.createElement('div');
      box.className = 'ssc-completer__group';
      const setsLabel = sets
        ? `${sets} complete set${sets === 1 ? '' : 's'} · building set ${target} of ${MAX_SETS} · `
        : '';
      box.innerHTML =
        `<div class="ssc-completer__head">
           <h2 class="ssc-completer__title">${L.heading} ${group} Special</h2>
           <span class="ssc-completer__progress">${setsLabel}${missing.length} design${missing.length === 1 ? '' : 's'} to go</span>
         </div>
         <div class="ssc-completer__rows"></div>
         <div class="ssc-completer__error" hidden></div>`;
      const rows = box.querySelector('.ssc-completer__rows');
      const errorEl = box.querySelector('.ssc-completer__error');

      missing.forEach(({ handle, need }) => {
        const meta = data.products[handle] || {};
        const variants = data.by_product[handle] || [];
        const row = document.createElement('div');
        row.className = 'ssc-completer__row';

        const options = variants
          .map(v => `<option value="${v.id}">${v.color}</option>`)
          .join('');

        row.innerHTML =
          `<img class="ssc-completer__thumb" src="${meta.image || ''}" alt="" loading="lazy" width="48" height="48">
           <a class="ssc-completer__name" href="${meta.url || '#'}">${meta.title || handle}
             <span class="ssc-completer__price">$${meta.price || ''}</span></a>
           <select class="ssc-completer__select" aria-label="Colorway for ${meta.title || handle}">
             <option value="">${L.choose}</option>${options}
           </select>
           <button type="button" class="ssc-completer__btn" disabled>${need > 1 ? `${L.add} ×${need}` : L.add}</button>`;

        const select = row.querySelector('select');
        const btn = row.querySelector('button');
        // Blank by default, so nothing lands in a wholesale order by accident.
        select.addEventListener('change', () => { btn.disabled = !select.value; });

        btn.addEventListener('click', async () => {
          if (!select.value) return;
          btn.disabled = true;
          btn.textContent = L.adding;
          errorEl.hidden = true;
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              // Exactly the shortfall for the set being built.
              body: JSON.stringify({ items: [{ id: Number(select.value), quantity: need }] }),
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok || body.status) {
              throw new Error(body.description || body.message || `add failed (${res.status})`);
            }
            // Full reload: the cart lines, the totals and Bundler's own
            // completion notice all have to recalculate together.
            window.location.reload();
          } catch (err) {
            errorEl.textContent = err.message || 'Could not add that. Please try again.';
            errorEl.hidden = false;
            btn.disabled = false;
            btn.textContent = need > 1 ? `${L.add} ×${need}` : L.add;
          }
        });

        rows.appendChild(row);
      });

      root.appendChild(box);
    });

    root.hidden = shown === 0;
  }

  build();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-cart-total"]) return;
  try {
    
  (function () {
    const el = document.querySelector('[data-ssc-cart-total]');
    if (!el) return;
    const valEl = el.querySelector('[data-ssc-cart-total-val]');
    const countEl = el.querySelector('[data-ssc-cart-total-count]');

    // Mirrors Shopify's `money_without_trailing_zeros` for USD: whole
    // dollars show no cents, fractional totals show two decimals.
    function formatMoney(cents) {
      const amount = (cents || 0) / 100;
      const whole = Math.round(cents || 0) % 100 === 0;
      return '$' + amount.toLocaleString('en-US', {
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      });
    }

    function render(totalCents, count) {
      if (valEl) valEl.textContent = formatMoney(totalCents);
      if (countEl) countEl.textContent = count;
      el.hidden = !(count > 0);
    }

    // Re-render the server-provided initial values through the same
    // formatter so first paint and live updates always match.
    render(parseInt(el.dataset.totalCents, 10) || 0, parseInt(el.dataset.count, 10) || 0);

    let debounce;
    async function refreshFromCart() {
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        try {
          // Localized cart route when available (market/locale path
          // prefixes), falling back to the root AJAX endpoint.
          const cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
          const cart = await fetch(cartUrl, {
            headers: { 'Accept': 'application/json' },
          }).then((r) => r.json());
          render(cart.total_price, cart.item_count);
          if (cart.item_count > 0) {
            el.classList.remove('ssc-cart-total--bump');
            void el.offsetWidth; // force reflow so the animation restarts
            el.classList.add('ssc-cart-total--bump');
          }
        } catch (e) {
          /* keep last-known total on transient fetch failure */
        }
      }, 60);
    }

    // pubsub.js / constants.js load deferred in <head>; this bundled
    // section JS may run before they finish, so retry until ready.
    (function bind() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromCart);
      } else {
        setTimeout(bind, 200);
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-collection-palette-filter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript ? document.currentScript.closest('[data-ssc-palette]') : null;
    function applyActive() {
      const containers = document.querySelectorAll('[data-ssc-palette]');
      containers.forEach((container) => {
        const params = new URLSearchParams(window.location.search);
        let activeSlug = null;
        let activeName = null;
        params.forEach((value, key) => {
          if (key.startsWith('filter.')) {
            activeSlug = value.replace(/^color-family-/, '');
          }
        });
        const cells = container.querySelectorAll('[data-color-slug]');
        cells.forEach((cell) => {
          const isActive = activeSlug && cell.dataset.colorSlug === activeSlug;
          cell.classList.toggle('ssc-coll-palette__cell--active', isActive);
          if (isActive) activeName = cell.querySelector('.ssc-coll-palette__label')?.textContent || activeSlug;
        });
        const bar = container.querySelector('[data-ssc-palette-active]');
        if (!bar) return;
        if (activeSlug) {
          bar.hidden = false;
          const nameEl = bar.querySelector('[data-ssc-palette-active-name]');
          if (nameEl) nameEl.textContent = activeName || activeSlug;
        } else {
          bar.hidden = true;
        }
      });
    }
    applyActive();
    window.addEventListener('popstate', applyActive);
    // Trade's facet bar adds/removes filters via history.pushState (no popstate event),
    // so patch history once to emit 'locationchange' and re-evaluate the active bar then —
    // otherwise the "Filtering by …" notice lingers after a filter is removed on the bar.
    if (!window.__sscLocationChangePatched) {
      window.__sscLocationChangePatched = true;
      ['pushState', 'replaceState'].forEach(function (m) {
        var orig = history[m];
        history[m] = function () {
          var rv = orig.apply(this, arguments);
          window.dispatchEvent(new Event('locationchange'));
          return rv;
        };
      });
    }
    window.addEventListener('locationchange', applyActive);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // When a color-family filter is active, each card shows EVERY colorway the
    // product offers in that family, as a cluster of swatches (capped, +N overflow).
    // So a Blue filter shows "Skyy · Denim · Aqua" on one style, just "Skyy" on another.
    // Family membership comes from the SAME reviewed mapping the metafield filter uses
    // (ssc-colorfamily-map.json), so the swatches always match what the filter matched.
    var MAX_SHOWN = 8;
    function hz(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function activeFamily() {
      var fam = null;
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        // variantcolor metafield filter: ?filter.v.m.custom.variantcolor=Crystal
        if (k.indexOf('custom.variantcolor') !== -1) fam = v;
        // tag-based filter: ?filter.p.tag=color-family-crystal
        if (k === 'filter.p.tag' && v.indexOf('color-family-') === 0) fam = v.replace('color-family-', '');
      });
      return fam;
    }
    var mapCache = null;
    function getMap(url) {
      if (mapCache) return Promise.resolve(mapCache);
      return fetch(url).then(function (r) { return r.json(); })
        .then(function (j) { mapCache = j.colorways || {}; return mapCache; })
        .catch(function () { return {}; });
    }
    var vimgCache = null;
    function getVImgs(url) {
      if (vimgCache) return Promise.resolve(vimgCache);
      return fetch(url).then(function (r) { return r.json(); })
        .then(function (j) { vimgCache = j; return j; })
        .catch(function () { return {}; });
    }
    // Ordered candidate keys into the variant-image map. First hit per product wins.
    //
    // On a CURATION the chain is restricted to the curation's own colorways: the
    // clicked colorway first, then the rest of the curation's list, then the
    // crystal placeholder. The product's featured image is deliberately NOT a
    // fallback there — it's usually a non-curated colorway, which is how WEDDING
    // ended up showing styles in pink and green. Better a neutral placeholder
    // than a photo of a colorway the curation doesn't sell.
    //
    // Off a curation, behaviour is unchanged: family photo → crystal photo →
    // crystal placeholder → featured_media.
    function swapImages(fam, vimgMap, curationList, liveMap, isColorway) {
      var hasData = vimgMap && Object.keys(vimgMap).length > 0;
      var hasLive = liveMap && Object.keys(liveMap).length > 0;
      var keys = [];
      if (fam) keys.push(hz(fam));
      (curationList || []).forEach(function (c) { keys.push(hz(c)); });
      var isCuration = !!(curationList && curationList.length);
      // 'crystal' is the whitest image in the catalogue. It's the right last
      // resort on a normal collection, and on a curation that actually sells
      // Crystal — but on ENTOURAGE it turned a dark curation's cards white.
      // Only fall back to it when the curation asked for it.
      //
      // It is also wrong when ONE colorway was asked for. A family filter is a
      // broad "show me the blues", where a neutral stand-in is reasonable; a
      // colorway filter is a specific question, and answering it with Crystal
      // on every design that lacks a photo produces a page of identical white
      // cards you cannot tell apart. Only 25 of the 210 designs offered in
      // Leopard have a Leopard photograph, so that is the common case, not the
      // edge. Those cards keep their own featured image instead: it is the
      // wrong colorway, but it shows the design, which is what the buyer is
      // scanning for. The colorway they filtered to is not in doubt — they
      // typed it.
      var crystalOk = (!isCuration || keys.indexOf('crystal') !== -1) && !isColorway;
      if (crystalOk) keys.push('crystal');
      keys = keys.filter(function (k, i) { return k && keys.indexOf(k) === i; });
      var crystalVarMap = hasData ? (vimgMap['crystal'] || {}) : null;
      document.querySelectorAll('[data-ssc-handle]').forEach(function (card) {
        var img = card.querySelector('.card__media img');
        if (!img) return;
        var handle = card.getAttribute('data-ssc-handle') || '';
        var targetSrc = null;
        // The live per-colorway lookup outranks every static key: it is the exact
        // colorway the buyer asked for, where the map's keys are only ever the
        // family it belongs to.
        if (hasLive && liveMap[handle]) targetSrc = liveMap[handle];
        if (!targetSrc && (fam || isCuration)) {
          for (var i = 0; i < keys.length && !targetSrc; i++) {
            var m = hasData ? vimgMap[keys[i]] : null;
            if (m && m[handle]) targetSrc = m[handle];
          }
          if (!targetSrc && crystalOk) {
            // Same reasoning: this placeholder IS a crystal render, so it's
            // guaranteed-wrong on a curation that sells no crystal. Those cards
            // keep their own featured image instead — unpredictable, but at
            // least it's the design's hero shot rather than a white one.
            var crystalUrl = card.getAttribute('data-ssc-crystal-url');
            if (crystalUrl) targetSrc = crystalUrl;
          }
        }
        // Substitute-colour chip. When ONE colorway was asked for and this design
        // has no photograph of it, the card is showing some other colour — so say
        // so, rather than letting a Crystal or Bloom shot pass as Leopard.
        //
        // "Available in X" is the honest claim: the storefront facet only returns
        // products that genuinely offer that colorway, so the design IS available
        // in it. Only the photography is missing. Mirrors the color-family cards.
        //
        // Rebuilt every render() — the grid re-renders on popstate and on every
        // facet AJAX swap, so a stale chip would otherwise outlive its filter.
        var oldChip = card.querySelector('[data-ssc-substitute]');
        if (oldChip) oldChip.remove();
        if (isColorway && !targetSrc) {
          var chip = document.createElement('div');
          chip.className = 'ssc-card-substitute';
          chip.setAttribute('data-ssc-substitute', '');
          chip.textContent = 'Available in ' + fam;
          card.appendChild(chip);
        }

        if (targetSrc) {
          if (!img.getAttribute('data-orig-src')) {
            img.setAttribute('data-orig-src', img.getAttribute('src') || '');
            img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
          }
          img.src = targetSrc;
          img.removeAttribute('srcset');
        } else {
          var orig = img.getAttribute('data-orig-src');
          if (orig) {
            img.src = orig;
            var origSet = img.getAttribute('data-orig-srcset');
            if (origSet) img.srcset = origSet; else img.removeAttribute('srcset');
          }
        }
      });
    }
    // On a curation collection with no filter applied, fall back to the curation's
    // own colorways rather than the product's featured image — otherwise WEDDING
    // shows styles in pink and green. The variant-image map is keyed by FAMILY, so
    // walk the curated colorways in order and take the first whose slug is a key
    // ('Crystal' -> crystal, 231 handles). Curations whose colorways don't resolve
    // to a key fall through to the crystal tier inside swapImages.
    // Curation pills are a VIEW switch, not a filter — ?colorway=Ice re-images
    // every card to its Ice photo. Product-level colour filtering is close to
    // useless on a curation: the collection holds whole products and nearly
    // every design comes in every colorway, so the storefront filter reports
    // ~92 of 92 products for most colours. The map now carries colorway keys
    // (ice, crystal-pearl) alongside family keys, so this feeds the same
    // swapImages() path and inherits its family/crystal fallbacks.
    function activeColorway() {
      var p = new URLSearchParams(window.location.search);
      // ?colorway=Ice is the curation view-switch. filter.v.option.color is the
      // storefront's own variant-option facet, which every by-color surface
      // links to (the ribbon, the New-2026 strip, the group sections) and which
      // this code used to ignore entirely — so those links filtered the PRODUCT
      // list but left every card showing its default image.
      return p.get('colorway') || p.get('filter.v.option.color');
    }
    function render() {
      var grid = document.querySelector('[data-ssc-colormap]');
      if (!grid) return;
      var chips = document.querySelectorAll('[data-ssc-card-colorchip]');
      var fam = activeFamily();
      var curationRaw = grid.getAttribute('data-ssc-curation');
      var curationList = curationRaw ? curationRaw.split('|').filter(Boolean) : [];
      var isCuration = curationList.length > 0;
      var cw = activeColorway();
      var vimgsUrl = grid.getAttribute('data-ssc-vimgs-url');
      // A specific colorway is resolved live rather than from the static map,
      // which only carries family buckets — see assets/ssc-colorway-images.js.
      // Scoped to the handles actually rendered, so it costs one request per
      // page of cards and works on /collections/all, which has no Storefront
      // collection handle to query. Resolves to {} when the colorway has no
      // photography, and swapImages then falls through its normal
      // family -> crystal -> featured chain.
      var pageHandles = [];
      document.querySelectorAll('[data-ssc-handle]').forEach(function (c) {
        var h = c.getAttribute('data-ssc-handle');
        if (h) pageHandles.push(h);
      });
      var livePromise = (cw && pageHandles.length && window.sscLoadColorwayImages)
        ? window.sscLoadColorwayImages(pageHandles, cw)
        : Promise.resolve(null);

      if (vimgsUrl) {
        Promise.all([getVImgs(vimgsUrl), livePromise]).then(function (r) {
          // Clicked colorway wins; the curation's remaining colorways are the
          // fallback chain, so a product with no Ice photo shows Crystal rather
          // than whatever its featured image happens to be.
          // isColorway: a single colorway was asked for, so suppress the crystal
          // fallback for designs that have no photo of it.
          swapImages(cw || fam, r[0], curationList, r[1], Boolean(cw));
        });
      } else {
        livePromise.then(function (live) {
          swapImages(cw || fam, null, curationList, live, Boolean(cw));
        });
      }
      // Chips list the colorways within an active FAMILY; on a curation the grid
      // is already one colorway, so they'd be noise.
      if (!fam || isCuration) { chips.forEach(function (c) { c.hidden = true; c.innerHTML = ''; }); return; }
      getMap(grid.getAttribute('data-ssc-colormap')).then(function (map) {
        chips.forEach(function (c) {
          var list = (c.getAttribute('data-ssc-colorways') || '').split('|').filter(Boolean);
          var seen = {}, matches = [];
          for (var i = 0; i < list.length; i++) {
            var k = hz(list[i]);
            if (seen[k]) continue;
            var e = map[k];
            if (e && e.f && e.f.indexOf(fam) !== -1) { seen[k] = 1; matches.push({ name: list[i], u: e.u, h: e.h }); }
          }
          if (!matches.length) { c.hidden = true; c.innerHTML = ''; return; }
          var shown = matches.slice(0, MAX_SHOWN);
          var html = shown.map(function (m) {
            var st = m.u ? 'background-image:url(' + m.u + ');' : 'background:' + (m.h || '#ccc') + ';';
            return '<span class="ssc-card-colorchip__dot" style="' + st + '" title="' + m.name + '"></span>';
          }).join('');
          var extra = matches.length - shown.length;
          if (extra > 0) html += '<span class="ssc-card-colorchip__more">+' + extra + '</span>';
          c.innerHTML = html;
          c.hidden = false;
        });
      });
    }
    render();
    window.addEventListener('popstate', render);
    // Re-apply chips after the facet filter AJAX swaps #ProductGridContainer's contents.
    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && window.MutationObserver) {
      new MutationObserver(function () { render(); }).observe(gridContainer, { childList: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-dashboard-reorder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ssc-reorder]');
    if (!btn) return;
    e.preventDefault();
    const variantId = parseInt(btn.dataset.variantId, 10);
    const qty = parseInt(btn.dataset.qty, 10) || 1;
    if (!variantId) return;
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
      });
      if (!res.ok) throw new Error('cart add failed: ' + res.status);
      window.location.href = '/cart';
    } catch (err) {
      console.error('[ssc-reorder]', err);
      btn.disabled = false;
      btn.textContent = originalText;
      alert('Could not add to cart. Please try again.');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Publishes the header's rendered height as --header-height on
    // :root, and implements three sticky-behavior modes that map to
    // the section's `sticky_header_type` setting:
    //   - none             → no sticky (handled in Liquid by omitting
    //                         the .ssc-header--sticky class)
    //   - always           → CSS-only sticky, no JS needed here
    //   - on-scroll-up     → hide while scrolling down past a small
    //                         threshold, reveal when scrolling up
    //   - reduce-logo-size → always sticky, shrink padding/logo once
    //                         scrolled past a threshold
    // Replaces the corresponding piece of Trade's StickyHeader class
    // (which lived in their now-replaced header section).
    const header = document.querySelector('.section-header');
    if (!header) return;

    const setH = () => {
      const h = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', `${Math.round(h)}px`);
    };
    setH();
    window.addEventListener('resize', setH);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setH).observe(header);
    }

    const stickyType = header.getAttribute('data-sticky-type');
    if (stickyType !== 'on-scroll-up' && stickyType !== 'reduce-logo-size') return;

    const SCROLL_THRESHOLD = 50;     // px before any sticky behavior kicks in
    const HIDE_DELTA = 6;             // px movement needed to flip direction
    let lastY = window.scrollY;
    let ticking = false;

    function update() {
      const y = window.scrollY;
      const delta = y - lastY;

      if (stickyType === 'reduce-logo-size') {
        header.classList.toggle('ssc-header--reduced', y > SCROLL_THRESHOLD);
      } else if (stickyType === 'on-scroll-up') {
        // Past threshold: hide on downward scroll, reveal on upward.
        // Always show when near top of page.
        if (y < SCROLL_THRESHOLD) {
          header.classList.remove('ssc-header--hidden');
        } else if (delta > HIDE_DELTA) {
          header.classList.add('ssc-header--hidden');
          // Close menu if it's open while we hide the header — otherwise
          // the menu would stay anchored to a hidden header.
          const menu = document.querySelector('[data-ssc-megamenu]');
          if (menu && menu.classList.contains('open')) {
            const closeBtn = menu.querySelector('[data-ssc-megamenu-close]');
            if (closeBtn) closeBtn.click();
          }
        } else if (delta < -HIDE_DELTA) {
          header.classList.remove('ssc-header--hidden');
        }
      }

      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-linesheets-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ssc-linesheets]').forEach((root) => {
      const filterBar = root.querySelector('.ssc-linesheets__filters');
      if (!filterBar) return;
      filterBar.addEventListener('click', (e) => {
        const btn = e.target.closest('.ssc-linesheets__pill');
        if (!btn || !filterBar.contains(btn)) return;
        const cat = btn.dataset.cat || '';
        // toggle off if clicking the already-active filter (and it's not the "all" pill)
        const wasActive = btn.classList.contains('ssc-linesheets__pill--active');
        const activeCat = (wasActive && cat) ? '' : cat;
        filterBar.querySelectorAll('.ssc-linesheets__pill').forEach((b) => {
          const isActive = (b.dataset.cat || '') === activeCat;
          b.classList.toggle('ssc-linesheets__pill--active', isActive);
          b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        root.querySelectorAll('.ssc-linesheet-card').forEach((card) => {
          card.style.display = (!activeCat || (card.dataset.cat || '') === activeCat) ? '' : 'none';
        });

        // The price-list block keeps its own heading, so hide the whole block
        // when a filter leaves it with no visible cards — otherwise the
        // heading sits above empty space.
        const priceBlock = root.querySelector('[data-ssc-pricelist-block]');
        if (priceBlock) {
          const anyVisible = Array.from(priceBlock.querySelectorAll('.ssc-linesheet-card'))
            .some((card) => card.style.display !== 'none');
          priceBlock.style.display = anyVisible ? '' : 'none';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-market-specials-groups"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-ssc-msgroups]');
  if (!root) return;

  // Per-order cap agreed 2026-08-10. Matches ssc-cart-bundle-completer.liquid;
  // if one changes the other has to.
  const MAX_SETS = 5;

  const L = {
    heading: root.dataset.heading || 'Market Specials',
    choose: root.dataset.chooseLabel || 'Colorway',
    add: root.dataset.addLabel || 'Add',
    adding: root.dataset.addingLabel || 'Adding…',
    inCart: root.dataset.incartLabel || 'In your cart',
    atCap: root.dataset.atcapLabel || 'Max per order',
    suffix: root.dataset.suffix || 'designs',
  };

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g,
    c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  async function build() {
    let data, cart;
    try {
      [data, cart] = await Promise.all([
        fetch(root.dataset.src).then(r => r.json()),
        fetch('/cart.js').then(r => r.json()),
      ]);
    } catch (err) {
      // An enhancement on a working cart — stay quiet and leave the page alone.
      console.warn('[ssc-msgroups] could not load bundle data', err);
      return;
    }

    // Which designs are already in the cart, by flagged variant id.
    const owner = new Map();
    Object.entries(data.by_product || {}).forEach(([handle, entries]) => {
      entries.forEach(e => owner.set(String(e.id), handle));
    });
    // Units per design, not mere presence — sets stack up to the cap.
    const units = {};
    (cart.items || []).forEach(i => {
      const h = owner.get(String(i.variant_id));
      if (h) units[h] = (units[h] || 0) + (i.quantity || 0);
    });

    const frag = document.createDocumentFragment();
    const h = document.createElement('h2');
    h.className = 'ssc-msgroups__heading';
    h.textContent = L.heading;
    frag.appendChild(h);

    const errorEl = document.createElement('div');
    errorEl.className = 'ssc-msgroups__error';
    errorEl.hidden = true;

    Object.entries(data.groups || {}).forEach(([group, handles]) => {
      const band = document.createElement('div');
      band.className = 'ssc-msgroups__band';
      // Complete sets = the weakest link across the grouping.
      const sets = Math.min(...handles.map(h => units[h] || 0));
      const setsNote = sets
        ? ` · ${sets} complete set${sets === 1 ? '' : 's'} of ${MAX_SETS}`
        : '';
      band.innerHTML =
        `<div class="ssc-msgroups__band-head">
           <h3 class="ssc-msgroups__band-name">${esc(group)}</h3>
           <span class="ssc-msgroups__band-count">${handles.length} ${esc(L.suffix)}${setsNote}</span>
         </div>
         <div class="ssc-msgroups__grid"></div>`;
      const grid = band.querySelector('.ssc-msgroups__grid');

      handles.forEach(handle => {
        const meta = data.products[handle] || {};
        const variants = data.by_product[handle] || [];
        const qty = units[handle] || 0;
        const atCap = qty >= MAX_SETS;

        const tile = document.createElement('div');
        tile.className = 'ssc-msgroups__tile' + (qty ? ' ssc-msgroups__tile--incart' : '');
        tile.innerHTML =
          `<a href="${esc(meta.url || '#')}"><img class="ssc-msgroups__img" src="${esc(meta.image || '')}" alt="" loading="lazy"></a>
           <a class="ssc-msgroups__name" href="${esc(meta.url || '#')}">${esc(meta.title || handle)}</a>
           <span class="ssc-msgroups__price">$${esc(meta.price || '')}</span>
           ${qty ? `<span class="ssc-msgroups__incart">${atCap ? esc(L.atCap) : esc(L.inCart) + ' ×' + qty}</span>` : ''}
           <select class="ssc-msgroups__select" aria-label="Colorway for ${esc(meta.title || handle)}">
             <option value="">${esc(L.choose)}</option>
             ${variants.map(v => `<option value="${v.id}">${esc(v.color)}</option>`).join('')}
           </select>
           <button type="button" class="ssc-msgroups__btn" disabled>${esc(L.add)}</button>`;

        const select = tile.querySelector('select');
        const btn = tile.querySelector('button');
        if (atCap) {
          // Five units already: another would only push this design past the cap
          // without completing a set.
          select.disabled = true;
        } else {
          select.addEventListener('change', () => { btn.disabled = !select.value; });
        }

        btn.addEventListener('click', async () => {
          if (!select.value) return;
          btn.disabled = true;
          btn.textContent = L.adding;
          errorEl.hidden = true;
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }] }),
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok || body.status) {
              throw new Error(body.description || body.message || `add failed (${res.status})`);
            }
            // Lines, totals, the completer above and Bundler's own notice all
            // have to recalculate together.
            window.location.reload();
          } catch (err) {
            errorEl.textContent = err.message || 'Could not add that. Please try again.';
            errorEl.hidden = false;
            btn.disabled = false;
            btn.textContent = L.add;
          }
        });

        grid.appendChild(tile);
      });

      frag.appendChild(band);
    });

    frag.appendChild(errorEl);
    root.innerHTML = '';
    root.appendChild(frag);
    root.hidden = false;
  }

  build();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-merch-notes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mnotes]');
    if (!root) return;

    var panes = Array.prototype.slice.call(root.querySelectorAll('[data-mnote-pane]'));
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-mnote-link]'));

    // With a single note there is nothing to switch between — leave the
    // unenhanced stacked layout alone.
    if (panes.length < 2) return;

    root.classList.add('is-enhanced');

    function activate(handle, updateHash) {
      var matched = false;

      panes.forEach(function (pane) {
        var on = pane.getAttribute('data-handle') === handle;
        pane.classList.toggle('is-active', on);
        if (on) matched = true;
      });

      if (!matched) return false;

      links.forEach(function (link) {
        var on = link.getAttribute('data-handle') === handle;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (updateHash && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#note-' + handle);
      }

      return true;
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var handle = link.getAttribute('data-handle');
        if (activate(handle, true)) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    window.addEventListener('hashchange', function () {
      var handle = (window.location.hash || '').replace('#note-', '');
      if (handle) activate(handle, false);
    });

    // Deep link wins; otherwise open the first note.
    var initial = (window.location.hash || '').replace('#note-', '');
    if (!initial || !activate(initial, false)) {
      activate(panes[0].getAttribute('data-handle'), false);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-product-bulk-matrix"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // SSC B2B: Liquid's product.variants tops out at 250 entries, so on
    // high-variant products the inline blob arrives truncated and the matrix
    // silently drops whole colorways (FALLON: 32 of 61 rows). For those products
    // we re-fetch the complete variant set from the Storefront API and rebuild
    // from it. Public read-only token — same one as assets/ssc-swatch-source.js;
    // keep the two in sync.
    const SF_API = '/api/2025-01/graphql.json';
    const SF_TOKEN = '8d390008d0df12ba863e973e6bfc926b';
    const SF_VARIANTS_QUERY = `
      query($handle: String!, $after: String) {
        product(handle: $handle) {
          options { name }
          variants(first: 250, after: $after) {
            pageInfo { hasNextPage endCursor }
            nodes { id title sku availableForSale price { amount } selectedOptions { name value } }
          }
        }
      }`;

    // Returns variants in the same shape the Liquid blob emits, so downstream
    // code can't tell which source it got. Shopify's per-product ceiling is
    // 2048 variants; the page guard is a runaway-loop backstop, not a cap.
    async function fetchAllVariants(handle) {
      const nodes = [];
      let optionNames = [];
      let after = null;
      for (let page = 0; page < 10; page++) {
        const res = await fetch(SF_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
          body: JSON.stringify({ query: SF_VARIANTS_QUERY, variables: { handle, after } })
        }).then(r => r.json());
        const product = res && res.data && res.data.product;
        if (!product || !product.variants) throw new Error('no product data for ' + handle);
        if (!optionNames.length) optionNames = (product.options || []).map(o => o.name);
        product.variants.nodes.forEach(n => nodes.push(n));
        if (!product.variants.pageInfo.hasNextPage) break;
        after = product.variants.pageInfo.endCursor;
      }
      // Map selectedOptions back onto option1/2/3 positions by name rather than
      // by array order, so the positional lookups downstream stay correct.
      return nodes.map(n => {
        const options = [null, null, null];
        (n.selectedOptions || []).forEach(o => {
          const i = optionNames.indexOf(o.name);
          if (i > -1 && i < 3) options[i] = o.value;
        });
        return {
          id: Number(String(n.id).split('/').pop()),
          title: n.title,
          sku: n.sku || '',
          available: n.availableForSale,
          price_cents: Math.round(parseFloat(n.price.amount) * 100),
          options: options
        };
      });
    }

    const moneyFormat = (cents, format) => {
      const dollars = (cents / 100);
      const formatted = dollars.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return '$' + formatted;
    };

    async function initMatrix(root) {
      const dataNode = root.querySelector('[data-ssc-matrix-data]');
      if (!dataNode) return;
      let data;
      try { data = JSON.parse(dataNode.textContent); } catch (e) { console.error('[ssc-matrix] bad JSON', e); return; }

      // Kick off the high-variant refetch before the swatch map so the two
      // round-trips overlap. Resolves to null when the blob wasn't truncated,
      // or when the fetch fails — in which case we keep the first 250 variants
      // rather than rendering nothing.
      const fullVariantsPromise = (data.variants_truncated && data.product_handle)
        ? fetchAllVariants(data.product_handle).catch(e => {
            console.error('[ssc-matrix] full variant fetch failed; showing first 250 only', e);
            return null;
          })
        : Promise.resolve(null);

      // Fetch the static swatch map (workaround for Shopify Liquid bug where
      // `shop.metaobjects.ssc_color[var]` returns the wrong entry after ~20
      // distinct dynamic lookups per render — see THEME-CUSTOMIZATIONS.md
      // 2026-06-01 entry). The fetched payload is store-wide; we only use
      // entries matching this product's row keys.
      const swatchMapUrl = root.dataset.sscSwatchMapUrl;
      let swatchData = { colors: {}, color_groups: [] };
      if (swatchMapUrl) {
        try { swatchData = await fetch(swatchMapUrl).then(r => r.json()); }
        catch (e) { console.error('[ssc-matrix] swatch map fetch failed', e); }
      }

      const rowIdx = parseInt(root.dataset.rowIndex, 10) - 1;
      const colAIdx = parseInt(root.dataset.colAIndex, 10) - 1;
      const colBIdx = parseInt(root.dataset.colBIndex, 10) - 1;
      const platingIdx = (parseInt(root.dataset.platingIndex, 10) || 0) - 1;
      const maxVisible = parseInt(root.dataset.maxVisible, 10) || 0;
      const cartAddUrl = root.dataset.cartAddUrl;
      const cartUrl = root.dataset.cartUrl;

      // Per-product pearl/ombre surcharge deltas (cents), keyed "pearl"/"ombre".
      const surcharges = data.colorway_surcharges || {};

      // Swap in the complete variant set when the Liquid blob was truncated.
      // The Storefront API doesn't know about settings.hidden_platings, so
      // re-apply it here — same rule the Liquid loop applies to the inline blob.
      const fullVariants = await fullVariantsPromise;
      if (fullVariants) {
        const hiddenPlatings = data.hidden_platings || [];
        const hiddenIdx = (data.plating_position || 0) - 1;
        const visible = (hiddenPlatings.length > 0 && hiddenIdx > -1)
          ? fullVariants.filter(v => hiddenPlatings.indexOf(v.options[hiddenIdx]) === -1)
          : fullVariants;
        // Only take over if it's genuinely a superset — a partial or stale
        // Storefront response should never shrink what Liquid already gave us.
        if (visible.length > (data.variants || []).length) data.variants = visible;
      }

      const variants = (data.variants || []).filter(v => v.options && v.options[rowIdx] != null);

      // Base price (min across all variants) and per-colorway min price. These
      // drive the mobile accordion's price display: the colorway's own price,
      // its surcharge vs base (colorwayMin − productMin), and each plating's
      // surcharge within the colorway (variantPrice − colorwayMin). All derived
      // from live variant prices, so gold/plating surcharges light up on their
      // own once that pricing goes live — no template change needed.
      const productMin = variants.length ? Math.min.apply(null, variants.map(v => v.price_cents)) : 0;
      const minByRowKey = new Map();
      variants.forEach(v => {
        const rk = v.options[rowIdx];
        if (rk == null) return;
        if (!minByRowKey.has(rk) || v.price_cents < minByRowKey.get(rk)) minByRowKey.set(rk, v.price_cents);
      });

      // Discover unique row keys (preserve first-seen order)
      const rowKeys = [];
      const colAKeys = [];
      const colBKeys = [];
      const seenRows = new Set();
      const seenColA = new Set();
      const seenColB = new Set();
      variants.forEach(v => {
        const r = v.options[rowIdx]; const a = v.options[colAIdx]; const b = v.options[colBIdx];
        if (r != null && !seenRows.has(r)) { seenRows.add(r); rowKeys.push(r); }
        if (a != null && !seenColA.has(a)) { seenColA.add(a); colAKeys.push(a); }
        if (b != null && !seenColB.has(b)) { seenColB.add(b); colBKeys.push(b); }
      });

      // Pin Plating display order (Palladium first) instead of trusting
      // first-seen variant order, which follows variant creation order
      // (14k Yellow) across the whole catalog. Whichever axis Plating
      // lands on gets re-sorted; unrecognized platings sort after the
      // named ones, in their original first-seen order.
      const PLATING_ORDER = ['Palladium', '14k Yellow', 'Rose Gold', 'Ruthenium'];
      const platingRank = (v) => {
        const i = PLATING_ORDER.indexOf(v);
        return i === -1 ? PLATING_ORDER.length : i;
      };
      const sortByPlating = (keys) => keys.sort((x, y) => platingRank(x) - platingRank(y));
      if (platingIdx === rowIdx) sortByPlating(rowKeys);
      if (platingIdx === colAIdx) sortByPlating(colAKeys);
      if (platingIdx === colBIdx) sortByPlating(colBKeys);

      // Build column tuples. Handles three cases:
      //   - both axes populated → cartesian product (e.g. Plating × Closure)
      //   - one axis populated → that axis only
      //   - neither axis populated → single "Quantity" column (single-option products)
      const sameAxis = colAIdx === colBIdx;
      const colAValues = colAKeys.length > 0 ? colAKeys : [null];
      const colBValues = (sameAxis || colBKeys.length === 0) ? [null] : colBKeys;
      const columns = colAValues.flatMap(a => colBValues.map(b => ({ a, b })));

      // Variant lookup: rowKey + colA + colB → variant
      // Use literal "null" string for missing axes so cell-key construction matches.
      const lookup = new Map();
      variants.forEach(v => {
        const a = v.options[colAIdx] != null ? v.options[colAIdx] : null;
        const b = (sameAxis || colBIdx == null) ? null : (v.options[colBIdx] != null ? v.options[colBIdx] : null);
        const k = [v.options[rowIdx], a, b].join('||');
        lookup.set(k, v);
      });

      // Render header
      const thead = root.querySelector('[data-ssc-matrix-thead]');
      const headerRow = document.createElement('tr');
      const rowLabelTh = document.createElement('th');
      rowLabelTh.textContent = data.row_label || 'Row';
      headerRow.appendChild(rowLabelTh);
      columns.forEach(c => {
        const th = document.createElement('th');
        if (c.a != null && c.b != null) {
          th.innerHTML = `${c.a}<br><span class="ssc-pdp-matrix__th-sub">${c.b}</span>`;
        } else if (c.a != null) {
          th.textContent = c.a;
        } else if (c.b != null) {
          th.textContent = c.b;
        } else {
          th.textContent = 'Quantity';
        }
        headerRow.appendChild(th);
      });
      const totalTh = document.createElement('th');
      totalTh.textContent = data.row_total_label || 'Row Total';
      totalTh.classList.add('ssc-pdp-matrix__th-total');
      headerRow.appendChild(totalTh);
      thead.appendChild(headerRow);

      // Render body
      const tbody = root.querySelector('[data-ssc-matrix-tbody]');
      const visibleRows = (maxVisible > 0 && rowKeys.length > maxVisible) ? rowKeys.slice(0, maxVisible) : rowKeys.slice();
      const hiddenRows = (maxVisible > 0 && rowKeys.length > maxVisible) ? rowKeys.slice(maxVisible) : [];

      // Build swatch lookup map keyed by handleized color value (matches
      // each metaobject entry's handle, which is the handleized color name).
      // Each swatch row also carries a pipe-delimited list of color group
      // slugs the colorway belongs to — drives the filter pill membership.
      const handleize = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      const swatchMap = new Map();
      const colorGroups = new Map();  // colorHandle → Set(groupSlug)
      // Build from the static swatch map JSON (fetched above). The payload is
      // keyed by handleized color name; each value has { url, hex, groups[] }.
      Object.entries(swatchData.colors || {}).forEach(([handle, info]) => {
        if (!info) return;
        swatchMap.set(handle, { url: info.url || null, hex: info.hex || null });
        if (Array.isArray(info.groups) && info.groups.length) {
          colorGroups.set(handle, new Set(info.groups));
        }
      });
      // SSC B2B: derive Ombre-family membership from the colorway name rather
      // than trusting the registry's groups. Only 13 of the 47 ombre colorways
      // live on active products actually carry the `ombre` group — the rest are
      // filed under their base hue alone (Ombre Emerald → green, Ombre Nude →
      // nude), which hid 7 of CAMILLE's 11 ombres behind the Ombre pill. Same
      // name test the surcharge badge below already relies on for the same
      // reason, and it catches the accented "Ombré" spellings that the handle
      // match drops. Verified store-wide: all 47 /ombr/ hits across 193 distinct
      // Color values are genuine ombres, no false positives.
      // Covers colorways the registry doesn't know about yet too: new ombres get
      // added to the catalog before their ssc_color entry exists (Ombre Gunmetal
      // and Ombre Lilac appeared mid-session on 2026-07-29), and since
      // applyFilter no longer shows unfamilied colorways under every pill, an
      // unregistered ombre would otherwise be missing from the Ombre pill
      // entirely. It still won't show under a hue pill — we don't know its hue.
      rowKeys.forEach((rowKey) => {
        if (!/ombr/i.test(rowKey || '')) return;
        const h = handleize(rowKey);
        if (!colorGroups.has(h)) colorGroups.set(h, new Set());
        colorGroups.get(h).add('ombre');
      });

      function buildRow(rowKey) {
        const tr = document.createElement('tr');
        tr.dataset.rowKey = rowKey;
        const labelTd = document.createElement('td');
        labelTd.className = 'ssc-pdp-matrix__row-label';
        const swatch = swatchMap.get(handleize(rowKey)) || {};
        let swatchStyle = '';
        if (swatch.url) {
          swatchStyle = `background-image: url('${swatch.url}'); background-size: cover; background-position: center;`;
        } else if (swatch.hex) {
          swatchStyle = `background: ${swatch.hex};`;
        }
        const swatchClass = swatch.url || swatch.hex
          ? 'ssc-pdp-matrix__row-swatch'
          : 'ssc-pdp-matrix__row-swatch ssc-pdp-matrix__row-swatch--empty';
        // Colorway surcharge badge (desktop grid). Classify by name: ombre
        // colorways read "Ombre/Ombré …" (the swatch `ombre` flag is incomplete
        // and accents break the handle match); pearl colorways read "… Pearl".
        const cinfo = (swatchData.colors || {})[handleize(rowKey)] || {};
        const rkLower = (rowKey || '').toLowerCase();
        let scCents = 0;
        if ((/ombr/.test(rkLower) || cinfo.ombre) && surcharges.ombre) scCents = surcharges.ombre;
        else if (/pearl/.test(rkLower) && surcharges.pearl) scCents = surcharges.pearl;
        const badge = scCents > 0
          ? `<span class="ssc-pdp-matrix__row-surcharge">+${moneyFormat(scCents)}</span>`
          : '';
        // Colorway's own min price + its surcharge vs product base — feeds the
        // mobile card header price (recalc fills the element from these attrs).
        const colorwayMin = minByRowKey.has(rowKey) ? minByRowKey.get(rowKey) : productMin;
        const cwDelta = colorwayMin - productMin;
        labelTd.innerHTML =
          '<div class="ssc-pdp-matrix__row-label-inner">' +
            `<span class="${swatchClass}" style="${swatchStyle}" aria-hidden="true"></span>` +
            '<div class="ssc-pdp-matrix__row-text">' +
              `<div class="ssc-pdp-matrix__row-name">${rowKey}</div>` +
              badge +
              `<div class="ssc-pdp-matrix__row-price" data-acc-price data-cw-min="${colorwayMin}" data-cw-delta="${cwDelta}"></div>` +
            '</div>' +
            '<span class="ssc-pdp-matrix__row-chevron" aria-hidden="true"></span>' +
          '</div>';
        tr.appendChild(labelTd);
        columns.forEach(c => {
          const td = document.createElement('td');
          td.className = 'ssc-pdp-matrix__qty-cell';
          const colLabel = (c.a != null && c.b != null) ? `${c.a} ${c.b}`
            : (c.a != null ? c.a : (c.b != null ? c.b : 'Quantity'));
          td.dataset.label = colLabel;
          const k = [rowKey, c.a, c.b].join('||');
          const v = lookup.get(k);
          // Plating name (+ its surcharge) — shown in the mobile card only; on
          // desktop it's hidden and just the input/dash renders in the grid cell.
          const platingLabel = document.createElement('span');
          platingLabel.className = 'ssc-pdp-matrix__plating';
          platingLabel.innerHTML = colLabel;
          if (v && v.available) {
            const platingDelta = v.price_cents - colorwayMin;
            if (platingDelta > 0) {
              platingLabel.innerHTML += ` <span class="ssc-pdp-matrix__plating-sc">(+${moneyFormat(platingDelta)})</span>`;
            }
            const inp = document.createElement('input');
            inp.type = 'number';
            inp.min = '0';
            inp.step = '1';
            inp.placeholder = '0';
            inp.className = 'ssc-pdp-matrix__qty';
            inp.dataset.variantId = v.id;
            inp.dataset.priceCents = v.price_cents;
            inp.dataset.rowKey = rowKey;
            const stepper = document.createElement('span');
            stepper.className = 'ssc-pdp-matrix__stepper';
            const minus = document.createElement('button');
            minus.type = 'button'; minus.className = 'ssc-pdp-matrix__step'; minus.dataset.step = '-1';
            minus.setAttribute('aria-label', 'Decrease quantity'); minus.textContent = '−';
            const plus = document.createElement('button');
            plus.type = 'button'; plus.className = 'ssc-pdp-matrix__step'; plus.dataset.step = '1';
            plus.setAttribute('aria-label', 'Increase quantity'); plus.textContent = '+';
            stepper.append(minus, inp, plus);
            td.append(platingLabel, stepper);
          } else if (v && !v.available) {
            td.className += ' ssc-pdp-matrix__qty-cell--unavail';
            td.append(platingLabel, Object.assign(document.createElement('span'), { className: 'ssc-pdp-matrix__na', textContent: '—' }));
          } else {
            td.className += ' ssc-pdp-matrix__qty-cell--missing';
            td.append(platingLabel, Object.assign(document.createElement('span'), { className: 'ssc-pdp-matrix__na', textContent: '·' }));
          }
          tr.appendChild(td);
        });
        const totalTd = document.createElement('td');
        totalTd.className = 'ssc-pdp-matrix__row-total ssc-pdp-matrix__row-total--zero';
        totalTd.dataset.rowKey = rowKey;
        totalTd.textContent = '0';
        tr.appendChild(totalTd);
        return tr;
      }

      visibleRows.forEach(r => tbody.appendChild(buildRow(r)));

      if (hiddenRows.length > 0) {
        const expandTr = document.createElement('tr');
        expandTr.className = 'ssc-pdp-matrix__expand-row';
        const expandTd = document.createElement('td');
        expandTd.colSpan = columns.length + 2;
        expandTd.textContent = (data.show_all_label || '+ Show all {n}').replace('{n}', rowKeys.length);
        expandTr.appendChild(expandTd);
        tbody.appendChild(expandTr);
        expandTr.addEventListener('click', () => {
          hiddenRows.forEach(r => tbody.insertBefore(buildRow(r), expandTr));
          expandTr.remove();
        });
      }

      // Meta line — extracted into a function so filter changes can refresh it.
      const metaEl = root.querySelector('[data-ssc-matrix-meta]');
      const onlyQty = columns.length === 1 && columns[0].a == null && columns[0].b == null;
      const colsPart = onlyQty ? '' : ` · ${columns.length} ${columns.length === 1 ? 'finish' : 'finishes'}`;
      function updateMeta(activeGroupSlug, activeGroupName) {
        if (!metaEl) return;
        const total = rowKeys.length;
        // Clear via .replaceChildren so we can append a link node when filtered.
        metaEl.replaceChildren();
        let rowsPart;
        if (activeGroupSlug) {
          const visibleInGroup = Array.from(tbody.querySelectorAll('tr[data-row-key]'))
            .filter(tr => tr.style.display !== 'none').length;
          const tpl = data.filter_meta_template || 'Showing {visible} of {total} options for {product}';
          rowsPart = tpl
            .replace('{visible}', visibleInGroup)
            .replace('{total}', total)
            .replace('{group}', activeGroupName)
            .replace('{product}', data.product_title || '');
        } else {
          const visCount = visibleRows.length;
          rowsPart = total === visCount
            ? `${total} ${total === 1 ? 'colorway' : 'colorways'}`
            : `Showing ${visCount} of ${total} colorways`;
        }
        metaEl.appendChild(document.createTextNode(rowsPart + colsPart));
        // Family link — only when a filter is active and a URL template is set.
        const linkTemplate = data.family_link_url_template;
        if (activeGroupSlug && linkTemplate) {
          metaEl.appendChild(document.createTextNode(' · '));
          const link = document.createElement('a');
          link.className = 'ssc-pdp-matrix__family-link';
          link.href = linkTemplate.replace('{slug}', encodeURIComponent(activeGroupSlug));
          const labelTpl = data.family_link_label || 'View {group} family';
          link.textContent = `${labelTpl.replace('{group}', activeGroupName)} →`;
          metaEl.appendChild(link);
        }
      }
      updateMeta(null, null);

      // Filter pills — rendered when section setting is on AND there's at
      // least one color group entry. Single-select: clicking the active
      // pill again clears the filter (shows every colorway, unfiltered).
      const showFilter = root.dataset.showFilter === 'true';
      const filterBar = root.querySelector('[data-ssc-matrix-filter]');
      // Transform fetched color_groups (array of {slug, name, display_order})
      // into the legacy [slug, name] tuple shape the rest of this function uses.
      const groupDefs = (swatchData.color_groups || []).map(g => [g.slug, g.name]);
      let activeGroup = null;  // null = show all

      function expandAllRows() {
        // Filter operates on rendered rows; if maxVisible has hidden some,
        // expand the rest first so the filter doesn't appear to "lose" rows
        // that are simply not in the DOM yet.
        const expandTr = tbody.querySelector('.ssc-pdp-matrix__expand-row');
        if (expandTr) expandTr.click();
      }

      function applyFilter(slug) {
        if (slug) expandAllRows();
        tbody.querySelectorAll('tr[data-row-key]').forEach((tr) => {
          const key = tr.dataset.rowKey;
          const groups = colorGroups.get(handleize(key));
          // A colorway with no family must not match a *specific* family filter.
          // This used to fall through to visible ("better to show an unmapped
          // colorway than hide it"), but that means an ungrouped colorway shows
          // under every pill — Cocoa and Chrome turned up under Ombre once the
          // brown/silver groups were deactivated and left them with no active
          // family. Claiming a colorway is an Ombre is worse than omitting it,
          // and it stays one click away: clicking the active pill clears the
          // filter and shows every row.
          const matches = !slug || Boolean(groups && groups.has(slug));
          tr.style.display = matches ? '' : 'none';
        });
        const def = groupDefs.find(([s]) => s === slug);
        updateMeta(slug, def ? def[1] : null);
      }

      // Only render pills for groups that have at least one colorway
      // in this product — hides zero-count families.
      // Build groupsInProduct from THIS product's row keys only — not the
      // store-wide colorGroups map (which now contains every color in the
      // catalog since the swatch-map workaround). Iterating colorGroups
      // directly would surface pills for families that don't appear on this
      // product at all.
      const groupsInProduct = new Set();
      rowKeys.forEach((rowKey) => {
        const groups = colorGroups.get(handleize(rowKey));
        if (groups) groups.forEach((s) => groupsInProduct.add(s));
      });
      const visibleGroupDefs = groupDefs.filter(([slug]) => groupsInProduct.has(slug));

      if (showFilter && filterBar && visibleGroupDefs.length > 0) {
        visibleGroupDefs.forEach(([slug, name]) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ssc-pdp-matrix__filter-pill';
          btn.textContent = name;
          btn.dataset.groupSlug = slug;
          btn.setAttribute('aria-pressed', slug === 'essentials' ? 'true' : 'false');
          filterBar.appendChild(btn);
        });
        filterBar.hidden = false;
        filterBar.addEventListener('click', (e) => {
          const btn = e.target.closest('.ssc-pdp-matrix__filter-pill');
          if (!btn || !filterBar.contains(btn)) return;
          const slug = btn.dataset.groupSlug || null;
          // Clicking the already-active group clears the filter.
          activeGroup = (slug === activeGroup) ? null : slug;
          filterBar.querySelectorAll('.ssc-pdp-matrix__filter-pill').forEach((b) => {
            b.setAttribute('aria-pressed', b.dataset.groupSlug === activeGroup ? 'true' : 'false');
          });
          applyFilter(activeGroup);
        });

        // Essentials is the default view on load. Falls back to showing
        // every colorway unfiltered on products that carry none of the
        // curated essentials colors.
        if (groupsInProduct.has('essentials')) {
          activeGroup = 'essentials';
          applyFilter('essentials');
        }
      }

      // Deep link from the color-family pages: /products/x?colorway=Ice
      //
      // Those cards picture one specific colorway and now say so on the chip, so
      // landing here in the default Essentials view — with that row very possibly
      // filtered out of sight — contradicts the card that was clicked.
      //
      // The filter is CLEARED rather than set to the colorway's family: a
      // colorway can belong to several families or none, so picking one is a
      // guess that can hide the very row we came here for. Showing every row is
      // always correct, and the pills are one click away.
      (function deepLinkColorway() {
        const want = new URLSearchParams(window.location.search).get('colorway');
        if (!want) return;
        const key = handleize(want);
        let target = null;
        tbody.querySelectorAll('tr[data-row-key]').forEach((tr) => {
          if (!target && handleize(tr.dataset.rowKey) === key) target = tr;
        });
        if (!target) return;   // colorway not on this product — leave the default view alone

        expandAllRows();
        activeGroup = null;
        applyFilter(null);
        if (filterBar) {
          filterBar.querySelectorAll('.ssc-pdp-matrix__filter-pill').forEach((b) => {
            b.setAttribute('aria-pressed', 'false');
          });
        }

        target.classList.add('is-deeplinked');
        // Deferred a frame so the row is laid out (and expanded) before we
        // measure where to scroll to.
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      })();

      // Footer pricing summary — "Base $X · Ombré +$Y · Pearl +$Z". Each type
      // shows only if the product carries that colorway. The plating (gold)
      // term derives from live prices, so it stays hidden until gold pricing
      // goes live, then appears on its own.
      let hasOmbreCw = false, hasPearlCw = false;
      rowKeys.forEach((rk) => {
        const rl = (rk || '').toLowerCase();
        const ci = (swatchData.colors || {})[handleize(rk)] || {};
        if (/ombr/.test(rl) || ci.ombre) hasOmbreCw = true;
        else if (/pearl/.test(rl)) hasPearlCw = true;
      });
      let platingSc = 0;
      variants.forEach((v) => {
        const cmin = minByRowKey.has(v.options[rowIdx]) ? minByRowKey.get(v.options[rowIdx]) : v.price_cents;
        const d = v.price_cents - cmin;
        if (d > platingSc) platingSc = d;
      });
      const summaryParts = [`Base ${moneyFormat(productMin)}`];
      if (hasOmbreCw && surcharges.ombre) summaryParts.push(`Ombré +${moneyFormat(surcharges.ombre)}`);
      if (hasPearlCw && surcharges.pearl) summaryParts.push(`Pearl +${moneyFormat(surcharges.pearl)}`);
      if (platingSc > 0) summaryParts.push(`Gold plating +${moneyFormat(platingSc)}`);
      const summaryEl = root.querySelector('[data-ssc-matrix-summary]');
      if (summaryEl && summaryParts.length > 1) {
        summaryEl.textContent = summaryParts.join(' · ');
        summaryEl.hidden = false;
      }

      // Totals + state
      const piecesEl = root.querySelector('[data-ssc-matrix-pieces]');
      const subtotalEl = root.querySelector('[data-ssc-matrix-subtotal]');
      const submitBtn = root.querySelector('[data-ssc-matrix-submit]');
      const submitLabel = root.querySelector('[data-ssc-matrix-submit-label]');
      const errorEl = root.querySelector('[data-ssc-matrix-error]');

      // Mobile card header price: "$sub · N pc" when the colorway has quantity,
      // else the colorway's own price (+ its surcharge vs base) from data attrs.
      function formatCardPrice(el, pieces, subtotalCents) {
        if (pieces > 0) {
          el.textContent = `${moneyFormat(subtotalCents)} · ${pieces} pc`;
        } else {
          const min = parseInt(el.dataset.cwMin, 10) || 0;
          const delta = parseInt(el.dataset.cwDelta, 10) || 0;
          el.innerHTML = moneyFormat(min) + (delta > 0
            ? ` <span class="ssc-pdp-matrix__row-price-delta">(+${moneyFormat(delta)})</span>` : '');
        }
      }

      function recalc() {
        let pieces = 0;
        let subtotalCents = 0;
        // Per-row totals
        const rowTotals = new Map();
        const rowSubtotals = new Map();
        root.querySelectorAll('.ssc-pdp-matrix__qty').forEach((inp) => {
          const q = parseInt(inp.value, 10) || 0;
          const price = parseInt(inp.dataset.priceCents, 10) || 0;
          if (q > 0) {
            inp.classList.add('ssc-pdp-matrix__qty--has-val');
            pieces += q;
            subtotalCents += q * price;
            const r = inp.dataset.rowKey;
            rowTotals.set(r, (rowTotals.get(r) || 0) + q);
            rowSubtotals.set(r, (rowSubtotals.get(r) || 0) + q * price);
          } else {
            inp.classList.remove('ssc-pdp-matrix__qty--has-val');
          }
        });
        root.querySelectorAll('[data-row-key]').forEach((td) => {
          if (!td.classList.contains('ssc-pdp-matrix__row-total')) return;
          const t = rowTotals.get(td.dataset.rowKey) || 0;
          td.textContent = t;
          td.classList.toggle('ssc-pdp-matrix__row-total--zero', t === 0);
        });
        root.querySelectorAll('[data-acc-price]').forEach((el) => {
          const tr = el.closest('tr');
          const rk = tr ? tr.dataset.rowKey : null;
          const pcs = rowTotals.get(rk) || 0;
          formatCardPrice(el, pcs, rowSubtotals.get(rk) || 0);
          if (tr) tr.classList.toggle('ssc-pdp-matrix__card--has-qty', pcs > 0);
        });
        if (piecesEl) piecesEl.textContent = pieces;
        if (subtotalEl) subtotalEl.textContent = moneyFormat(subtotalCents);
        if (submitBtn) submitBtn.disabled = pieces === 0;
      }

      root.addEventListener('input', (e) => {
        const t = e.target;
        if (!t.classList.contains('ssc-pdp-matrix__qty')) return;
        const v = parseInt(t.value, 10);
        if (Number.isNaN(v) || v < 0) t.value = '';
        recalc();
      });

      // Mobile interactions: stepper buttons adjust the adjacent qty input (the
      // input handler above then recalcs); tapping a card header toggles it open.
      root.addEventListener('click', (e) => {
        const step = e.target.closest('.ssc-pdp-matrix__step');
        if (step) {
          const inp = step.parentElement.querySelector('.ssc-pdp-matrix__qty');
          if (inp) {
            const next = Math.max(0, (parseInt(inp.value, 10) || 0) + (parseInt(step.dataset.step, 10) || 0));
            inp.value = next === 0 ? '' : String(next);
            inp.dispatchEvent(new Event('input', { bubbles: true }));
          }
          return;
        }
        const head = e.target.closest('.ssc-pdp-matrix__row-label');
        if (head) {
          const tr = head.closest('tr');
          if (tr) tr.classList.toggle('ssc-pdp-matrix__card--open');
        }
      });

      // Initial state
      recalc();

      submitBtn.addEventListener('click', async () => {
        const items = [];
        root.querySelectorAll('.ssc-pdp-matrix__qty').forEach((inp) => {
          const q = parseInt(inp.value, 10) || 0;
          if (q > 0) items.push({ id: parseInt(inp.dataset.variantId, 10), quantity: q });
        });
        if (!items.length) return;
        submitBtn.disabled = true;
        submitLabel.textContent = 'Adding…';
        errorEl.hidden = true;

        // Honor Trade's cart_type setting: drawer / notification popup / page.
        // Important: cart-notification (popup) only handles single-item adds —
        // its getSectionsToRender() uses cartItemKey from the single-item
        // response, which doesn't exist on bulk add responses ({items:[]}).
        // So we prefer cart-drawer here. If only cart-notification is on the
        // page (popup-only setup), fall back to /cart redirect since the
        // popup can't render a multi-item add.
        //
        // Use form-encoded POST (not JSON) so Shopify reliably populates
        // response.sections with the rendered drawer HTML — this matches
        // Trade's own product-form pattern.
        const cart = document.querySelector('cart-drawer');
        const formData = new FormData();
        items.forEach((item, i) => {
          formData.append(`items[${i}][id]`, String(item.id));
          formData.append(`items[${i}][quantity]`, String(item.quantity));
        });
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map((s) => s.id).join(','));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(submitBtn);
        }

        try {
          const r = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const response = await r.json().catch(() => ({}));
          if (!r.ok || response.status) {
            throw new Error(response.description || response.message || `cart add failed (${r.status})`);
          }
          if (cart) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ssc-product-bulk-matrix', cartData: response });
            }
            cart.renderContents(response);
            // Reset the matrix so the buyer can stack another order in the same session.
            root.querySelectorAll('.ssc-pdp-matrix__qty').forEach((inp) => { inp.value = ''; inp.classList.remove('has-val'); });
            submitBtn.disabled = false;
            submitLabel.textContent = data.submit_label || 'Add to order →';
            recalc();
          } else {
            window.location.href = cartUrl;
          }
        } catch (err) {
          errorEl.textContent = err.message || 'Could not add to cart. Please try again.';
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitLabel.textContent = data.submit_label || 'Add to order →';
          recalc();
        }
      });
    }

    document.querySelectorAll('[data-ssc-matrix]').forEach(initMatrix);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-product-top"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ssc-gallery]').forEach((root) => {
    // image_tag filter strips hyphenated data-* attrs, so target the main
    // image by its class instead of a data attribute. Same for srcset —
    // we update both so retina sources don't override our chosen image.
    const main = root.querySelector('.ssc-pdp-top__gallery-img');
    const thumbs = root.querySelectorAll('[data-ssc-gallery-thumb]');
    if (!main || !thumbs.length) return;

    const caption = root.querySelector('[data-ssc-gallery-caption]');

    function setMain(src, alt) {
      if (!src) return;
      main.setAttribute('src', src);
      main.setAttribute('alt', alt || '');
      // The caption is the same string as alt — "NAME in <colorway>", or
      // "NAME in Custom Color" for an image not attached to a variant.
      main.setAttribute('title', alt || '');
      if (caption) caption.textContent = alt || '';
      // Drop any srcset/sizes that the original image_tag emitted, so
      // browsers don't pick a different image based on viewport.
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
    }

    function setActive(thumb) {
      thumbs.forEach((t) => t.classList.remove('ssc-pdp-top__gallery-thumb--active'));
      thumb.classList.add('ssc-pdp-top__gallery-thumb--active');
    }

    // Capture the original src/alt so hover-preview can revert cleanly
    // before the user has clicked any thumb. After the first click,
    // mouseleave reverts to that "sticky" thumb instead.
    const originalSrc = main.getAttribute('src');
    const originalAlt = main.getAttribute('alt') || '';
    let stickyThumb = null;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setMain(thumb.dataset.fullSrc, thumb.dataset.alt);
        setActive(thumb);
        stickyThumb = thumb;
      });
      thumb.addEventListener('mouseenter', () => {
        setMain(thumb.dataset.fullSrc, thumb.dataset.alt);
      });
    });

    const thumbsWrap = root.querySelector('.ssc-pdp-top__gallery-thumbs');
    if (thumbsWrap) {
      thumbsWrap.addEventListener('mouseleave', () => {
        if (stickyThumb) {
          setMain(stickyThumb.dataset.fullSrc, stickyThumb.dataset.alt);
        } else {
          setMain(originalSrc, originalAlt);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
